import { ForecastProvider } from '../providers/forecastProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';


export const GET_DAILY_FORECAST_BY_LATLON = new AsyncAction('GET_DAILY_FORECAST_BY_LATLON');

export function getDailyForecastByLatLon(...params) {
    let paramsObject = {
        location: undefined,
        locationType: undefined,
        offset: undefined,
        units: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        tempUnit: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_DAILY_FORECAST_BY_LATLON.base,
        payload: getDailyForecast(paramsObject)
    };
}

export async function getDailyForecast({
    location,
    locationType,
    offset,
    units,
    baseUrl,
    authId,
    secret,
    stdParameters,
    verbose,
    refresh,
    tempUnit
}) {
    const op = new ForecastProvider(baseUrl, authId, secret);
    return await op.getDailyForecast(
        location,
        locationType,
        offset,
        units,
        stdParameters,
        verbose,
        refresh,
        tempUnit
    );
}
